import React, { useEffect } from 'react'
import { useQuery, useMutation } from 'react-query'
import { useHistory, useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { getCrawlerData } from 'common/utils'
import { toast } from 'react-toastify'
import Row from 'components/ui/Row'
import Col from 'components/ui/Col'
import TextField from 'components/form/TextField'
import Checkbox from 'components/form/Checkbox'
import Button from 'components/form/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'

const RssForm = (props) => {
  const history = useHistory()
  const { id } = useParams()
  const { handleSubmit, control, setValue, formState: { errors }, setError } = useForm()

  const { data: dataInfo } = useQuery(['getInfoRss', id], async () => {
    if (id) {
      return await getCrawlerData('GET', `vtcnews/${id}/`)
    }
  })

  const mutation = useMutation(async (dataForm) => {
    if (dataForm) {
      if (id) {
        return await getCrawlerData('PUT', `vtcnews/${id}/`, dataForm)
      } else {
        return await getCrawlerData('POST', 'vtcnews/', dataForm)
      }
    }
  })

  useEffect(() => {
    if (dataInfo) {
      setValue('title', dataInfo.title)
      setValue('link', dataInfo.link)
      setValue('is_active', dataInfo.is_active)
    }
  }, [dataInfo])

  /* ----------------------------------------------- */
  /* --------------- Handle Event ------------------ */
  /* ----------------------------------------------- */
  const onSubmit = async (data) => {
    try {
      if (id) {
        await mutation.mutateAsync({
          title: data.title,
          link: data.link,
          is_active: typeof data.is_active === 'undefined' ? true : data.is_active
        })
      } else {
        await mutation.mutateAsync({
          title: data.title,
          link: data.link,
          is_active: typeof data.is_active === 'undefined' ? true : data.is_active,
          tenant: localStorage.getItem('tenant')
        })
      }
      history.goBack()
    } catch (err) {
      if (err.response && err.response.status === 400) {
        const errData = err.response.data && err.response.data.errors
        if (typeof errData === 'object') {
          for (const item in errData) {
            const errItemArr = errData[item]
            setError(item, {
              type: 'manual',
              message: Array.isArray(errItemArr) && errItemArr[0]
            })
          }
        }
      } else {
        toast.error('Something went wrong!')
      }
      console.log(err)
    }
  }

  const handleCancel = () => {
    history.goBack()
  }

  return (
    <div className="people-form">
      <Card>
        <CardContent>
          <Row className="pt-3">
            <Col md={6} className="offset-md-3">
              <TextField label="Title" name="title" required control={control} error={errors.title} />
            </Col>
          </Row>
          <Row className="pt-3">
            <Col md={6} className="offset-md-3">
              <TextField label="Link" name="link" required control={control} error={errors.link} />
            </Col>
          </Row>
          <Row className="pt-4">
            <Col md={6} className="offset-md-3">
              <Checkbox name="is_active" control={control} defaultChecked label="Active" />
            </Col>
          </Row>
        </CardContent>
        <CardActions className="card-action-mui">
          <Button className="mr-2 d-inline-block" color="error" onClick={handleCancel}>Cancel</Button>
          <Button className="mr-2 d-inline-block" onClick={handleSubmit(onSubmit)}>Save</Button>
        </CardActions>
      </Card>
    </div>
  )
}

export default RssForm
